import React from 'react';
import { Navigate } from 'react-router-dom';
import { RoutePermittedRole } from '../../constants/AppEnums';

const IngresosDeMercaderia = React.lazy(
  () => import('../../../modules/blueSoft/Stock/IngresosDeMercaderia'),
);
const SalidasDeMercaderia = React.lazy(
  () => import('../../../modules/blueSoft/Stock/SalidasDeMercaderia'),
);
const EdicionMovimientoDeMercaderia = React.lazy(
  () => import('../../../modules/blueSoft/Stock/EdicionMovimientoDeMercaderia'),
);
const Stock = React.lazy(() => import('../../../modules/blueSoft/Stock'));

const Productos = React.lazy(
  () => import('../../../modules/blueSoft/Stock/Productos'),
);

const RotacionDeStock = React.lazy(
  () => import('../../../modules/blueSoft/Stock/RotacionDeStock'),
);

const ProductoVista = React.lazy(
  () => import('../../../modules/blueSoft/Stock/ProductoVista'),
);

const MateriasPrimas = React.lazy(
  () => import('../../../modules/blueSoft/Stock/MateriasPrimas'),
);

const Documento = React.lazy(
  () => import('../../../modules/blueSoft/Components/DocumentoView'),
);
const DocumentoPrint = React.lazy(
  () => import('../../../modules/blueSoft/Components/DocumentoPrintView'),
);

export const blueSoftPagesConfigs = [
  {
    permittedRole: RoutePermittedRole.User,
    path: '/blueSoft/inicio',
    element: <Navigate to='/blueSoft/stock/consulta' replace />,
  },
  {
    permittedRole: RoutePermittedRole.User,
    path: '/blueSoft/documento/view',
    element: <Documento />,
  },
  {
    permittedRole: RoutePermittedRole.User,
    path: '/blueSoft/documento/print',
    element: <DocumentoPrint />,
  },
  {
    permittedRole: RoutePermittedRole.User,
    path: '/blueSoft/producto/vista',
    element: <ProductoVista />,
  },
  {
    permittedRole: RoutePermittedRole.User,
    path: '/blueSoft/stock/productos',
    element: <Productos />,
  },
  {
    permittedRole: RoutePermittedRole.User,
    path: '/blueSoft/stock/materiasprimas',
    element: <MateriasPrimas />,
  },
  {
    permittedRole: RoutePermittedRole.User,
    path: '/blueSoft/stock/ingresos',
    element: <IngresosDeMercaderia />,
  },
  {
    permittedRole: RoutePermittedRole.User,
    path: '/blueSoft/stock/salidas',
    element: <SalidasDeMercaderia />,
  },
  {
    permittedRole: RoutePermittedRole.User,
    path: '/blueSoft/stock/ingresos/nuevo',
    element: <EdicionMovimientoDeMercaderia />,
  },
  {
    permittedRole: RoutePermittedRole.User,
    path: '/blueSoft/stock/ingresos/edicion',
    element: <EdicionMovimientoDeMercaderia />,
  },
  {
    permittedRole: RoutePermittedRole.User,
    path: '/blueSoft/stock/salidas/nueva',
    element: <EdicionMovimientoDeMercaderia />,
  },
  {
    permittedRole: RoutePermittedRole.User,
    path: '/blueSoft/stock/salidas/edicion',
    element: <EdicionMovimientoDeMercaderia />,
  },
  {
    permittedRole: RoutePermittedRole.User,
    path: '/blueSoft/stock/consulta',
    element: <Stock />,
  },
  {
    permittedRole: RoutePermittedRole.User,
    path: '/blueSoft/stock/rotacion',
    element: <RotacionDeStock />,
  },
];
